namespace Matrix.Data {
    export class CountryColumns {
        static columnsKey = 'Data.Country';
    }
}
